/* eslint-disable @typescript-eslint/no-unused-vars */

import {Injectable, inject} from '@angular/core';
import {LocalFileService} from '../local-file.service';
import {downloadBlob} from '../../../util/download-blob.util';
import {Vault} from 'src/app/api/models/vault';
import {ClipboardService} from '../../clipboard/clipboard.service';

@Injectable()
export class WebLocalFileService implements LocalFileService {
    private readonly clipboardService = inject(ClipboardService);

    public async saveFile(content: ArrayBuffer, filename: string, openFile: boolean = false): Promise<void> {
        const blob = new Blob([content], { type: 'application/octet-stream' });
        await new Promise(r => window.setTimeout(r, 1000)); // Timeout is needed for iOS Safari bug, which blocks all calls when the download of the file is running
        downloadBlob(blob, filename);
    }

    public async shareFile(content: ArrayBuffer, filename: string): Promise<void> {
        return this.saveFile(content, filename);
    }

    public async shareUrl(url: string): Promise<void> {
        await this.clipboardService.copyToClipboard(url);
    }

    public async createVaultDirectory(vault: Vault): Promise<void> {
    }
}
